import { SearchItem } from '../../../search';
import { StyledSearchResults } from './styled';

export interface SuggestionItem {
  itemsCategory: string;
  items?: string[];
}

export interface SearchListProps {
  data: SuggestionItem[];
  onClick?: () => void;
}

export const SearchList: React.FC<SearchListProps> = ({ data, onClick }) => (
  <StyledSearchResults onClick={onClick}>
    {data?.map(
      (suggestionItem) =>
        suggestionItem.items &&
        suggestionItem.items.map((itemNumber: any) => (
          <SearchItem
            key={itemNumber}
            itemCategory={suggestionItem.itemsCategory}
            itemNumber={itemNumber}
          />
        )),
    )}
  </StyledSearchResults>
);
